export class AwaitedOperation {
    constructor(
        public grp: string,
        public id: string
    ) { }
}